module.exports = {
  types: {
    C100: {
      label: "C10",
      tier: "C100",
      price: 0.125
    },
    C200: {
      label: "C200",
      tier: "C200",
      price: 0.225
    },
    C400: {
      label: "C400",
      tier: "C400",
      price: 0.45
    },
    order: ["C100", "C200", "C400"]
  },
  offline: {
    price: 0.075
  }
};
